<template>
    <div>
        <select class="form-control custom-select" name="group" id="group" v-model="groupIdValue" @change="onGroupChanged">
            <option :key="group.id" :value="group.id" v-for="group in groups">{{group.name}}</option>
        </select>
    </div>
</template>

<script lang="ts">
    import {Component, Vue, Watch} from "vue-property-decorator";
    import {HttpHandler} from "@/http/HttpHandler";
    import store from "@/store/index";

    @Component
    export default class AppGroupSelector extends Vue{
        groupIdValue: number | null = null;
        groups?: { id: number, name: string }[] = [];

        @Watch('groupIdValue')
        onGroupChanged() {
            this.$emit('input', this.groupIdValue);
        }

        async created() {
            const httpHandler = new HttpHandler(store);
            this.groups = await httpHandler.getQuestionGroups();

            if (this.groups && this.groups.length > 0) {
                this.groupIdValue = this.groups[0].id;
            }
        }
    }
</script>

<style scoped>

</style>
